import axios from 'axios';
import { processLicenseOrderPayloadType } from 'types/purchaseLicenseModalTypes';

export const getLicensePricingData = (
  ssoToken: string,
  corpAcctNbr: string,
  licenseDetailId: string,
  licenseQuantity: string,
) => {
  return axios.get(
    `/rest-api/commerce/v1/estimate-billing/corp-accounts/${corpAcctNbr}/license/${licenseDetailId}?quantity=${licenseQuantity}`,
    {
      headers: {
        'Content-Type': 'application/json',
        'nextiva-context-corpAcctNumber': corpAcctNbr,
        Authorization: `Bearer ${ssoToken}`,
      },
      withCredentials: true,
    },
  );
};

export const postLicenseOrder = (
  payload: processLicenseOrderPayloadType,
  ssoToken: string,
  corpAcctNbr: string,
  licenseDetailId: string,
) => {
  return axios.post(
    `/rest-api/commerce/v1/licenses/acquire/corp-accounts/${corpAcctNbr}/license/${licenseDetailId}`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
        'nextiva-context-corpAcctNumber': corpAcctNbr,
        Authorization: `Bearer ${ssoToken}`,
      },
      withCredentials: true,
    },
  );
};
